import { CreateLessonInput, Lesson } from "@hubcapp/types";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { Scalars } from "@hubcapp/graphql";

import createLessonMutation from "../graph-ql/createLesson.graphql";

const useMutationCreateLesson = (
  opts: MutationHookOptions<
    {
      createLesson: Lesson;
    },
    CreateLessonInput & {
      startDate: Scalars["GraphQLDate"];
      endDate: Scalars["GraphQLDate"];
    }
  > = {},
) =>
  useMutation(createLessonMutation, {
    ...opts,
  });

export default useMutationCreateLesson;
